import { locationMiddleware } from "../common/store/middleware/location";
import anonSessionSlice from "../common/store/slice/anonSessionSlice";
import authedSessionSlice from "../common/store/slice/authedSessionSlice";
import locationSlice from "../common/store/slice/locationSlice";
import notificationSlice from "../common/store/slice/notificationSlice";
import questionnaireSlice from "../common/store/slice/questionnaireSlice";
import userAnswersSlice from "../common/store/slice/userAnswersSlice";
import userPlanSlice from "../common/store/slice/userPlanSlice";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

const anonSessionConfig = {
  key: "anonSession",
  storage: storageSession,
};

const authedSessionConfig = {
  key: "auth",
  storage,
};

const locationConfig = {
  key: "location",
  storage,
};

const questionnaireConfig = {
  key: "questionnaire",
  storage: storageSession,
};

const answersConfig = {
  key: "userAnswers",
  storage: storageSession,
};

const planConfig = {
  key: "userPlan",
  storage: storageSession,
};

export const store = configureStore({
  devTools: true,
  reducer: combineReducers({
    notification: notificationSlice.reducer,
    anonSession: persistReducer(anonSessionConfig, anonSessionSlice.reducer),
    authedSession: persistReducer(
      authedSessionConfig,
      authedSessionSlice.reducer,
    ),
    location: persistReducer(locationConfig, locationSlice.reducer),
    questionnaire: persistReducer(
      questionnaireConfig,
      questionnaireSlice.reducer,
    ),
    userAnswers: persistReducer(answersConfig, userAnswersSlice.reducer),
    userPlan: persistReducer(planConfig, userPlanSlice.reducer),
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(locationMiddleware.middleware),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export function useAppDispatch() {
  return useDispatch<AppDispatch>();
}
